import React, { useCallback } from "react";
import { Button } from "native-base";
import { useCreateLetter } from "../../../hooks/useCreateLetter";
import { useCurrentUser } from "../../../hooks/useCurrentUser";
import { useAuthorFields } from "../../../hooks/useAuthorFields";
import { DocumentData, DocumentSnapshot } from "firebase/firestore";
import { DEFAULT_SALUTATION } from "../../web/components/SalutationField";

type Props = {
  project: DocumentSnapshot<DocumentData>;
};

export default function CreateProjectCoverLetterButton({ project }: Props) {
  const [user] = useCurrentUser();
  const [createLetter, isLoading] = useCreateLetter("projectCover");

  const author = useAuthorFields(user);

  const address = project.get("client") ?? "";
  const salutation = project.get("salutation") ?? DEFAULT_SALUTATION;
  const constructionSite = project.get("constructionSite") ?? "";
  const projectLead = (project.get("projectLead") as string) ?? "";

  const createCoverLetter = useCallback(() => {
    const payload = {
      address,
      salutation,
      author,
      constructionSite,
    };

    createLetter(payload, projectLead);
  }, [createLetter, address, salutation, author, constructionSite, projectLead]);

  return (
    <Button onPress={createCoverLetter} variant="solid" isLoading={isLoading}>
      Begleitschreiben Auftraggeber
    </Button>
  );
}
